import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ChartOptions, ChartType, Chart, registerables } from "chart.js";
import * as pluginDataLabels from "chartjs-plugin-datalabels";
import * as _ from "lodash";

@Component({
    selector: "approved-timecards-charts",
    templateUrl: "./approved-timecards.component.html",
    standalone: false
})
export class ApprovedTimecardsComponent implements OnChanges {
    @Input() chartData: any;

    data: any = [];
    barChartType: ChartType = "bar";
    barChartLegend = false;
    public barChartPlugins = [pluginDataLabels];
    barChartLabels = [];
    barChartData: any;
    barChartOptions = {
        responsive: true,
        barPercentage: 0.6,
        legend: {
            display: true,
        },
        scales: {
            x: {
                grid: {
                    display: false,
                    drawBorder: false,
                },
                border: {
                    display: false,
                },
            },
            y: {
                display: false,
            },
        },
        plugins: {
            datalabels: {
                anchor: "end",
                align: "start",
                backgroundColor: null,
                borderColor: null,
                borderRadius: 4,
                borderWidth: 0,
                color: "#000000",
                font: {
                    size: 11,
                    weight: 600,
                },
                offset: (context) => {
                    return context.dataset.data[context.dataIndex] === 0 ? -100 : 4; 
                },
                padding: 0,
                formatter: function (value) {
                    return Math.round(value * 10) / 10;
                },
            },
        },
    };

    setChartData() {
        this.barChartData = {
            labels: this.barChartLabels,
            datasets: [
                {
                    data: this.data,
                    backgroundColor: [
                        "yellow",
                        "yellow",
                        "yellow",
                        "yellow",
                        "yellow",
                        "yellow",
                        "yellow",
                    ],
                    hoverBackgroundColor: [
                        "yellow",
                        "yellow",
                        "yellow",
                        "yellow",
                        "yellow",
                        "yellow",
                        "yellow",
                    ],
                    borderWidth: 0,
                },
            ],
        };
    }

    modifyDataSet() {
        if (this.chartData) {
            _.forEach(this.chartData, (item) => {
                this.barChartLabels.push(item.approvedMonth);
                this.data.push(item.approvedCount);
            });
        }
        this.setChartData();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === "chartData") {
                const current = changes["chartData"]["currentValue"];
                this.chartData = current?.approvedTimeCardSummary;
                this.modifyDataSet();
            }
        }
    }
}
